import { useQuery } from '@tanstack/react-query';
import { privateApi } from '../api-clients/rest-client';

async function getOnramperUrl(): Promise<string> {
  const { url } = await privateApi.get('/onramper/url');
  return url;
}

export default function useOnramperUrl() {
  return useQuery({
    queryKey: ['/onramper/url'],
    queryFn: getOnramperUrl,
    staleTime: 10 * 60 * 1_000,
  });
}
